import React, { useState } from 'react';
import { Plus } from 'react-feather';

const ButtonTest = () => {
  const [showModal, setShowModal] = useState(false);
  const [clickCount, setClickCount] = useState(0);

  const handleClick = () => {
    console.log('Button clicked!');
    setClickCount(prev => prev + 1);
    setShowModal(true);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Button Test Page</h2>
      <p>Click count: {clickCount}</p>
      
      <button 
        style={{
          background: '#007bff',
          color: 'white',
          border: 'none',
          padding: '12px 20px',
          borderRadius: '8px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '14px',
          fontWeight: '500',
          margin: '10px 0'
        }}
        onClick={handleClick}
      >
        <Plus size={16} />
        Test Button
      </button>

      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '400px'
          }}>
            <h3>Modal Test</h3>
            <p>Button is working! Click count: {clickCount}</p>
            <button 
              onClick={() => setShowModal(false)}
              style={{
                background: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ButtonTest;